import * as angular from 'angular';
import '@uirouter/angularjs';
import 'angular-translate';
import 'angular-cookies';
import 'angular-sanitize';
import 'ngstorage';
import 'angular-ui-bootstrap/src/tabs/tabs.js';
import 'angular-hotkeys';
import 'angularjs-slider';
import 'angularjs-slider/dist/rzslider.css';
import 'html2canvas';

import skicky from '../blocks/sticky';
import routeConfig from './core.route';
import { localeConfig } from './i18n/i18n.config';
import { APIEndpoint, GlobalRedirects } from './core.config';
import { InterceptorsService } from './core.interceptors';

const core = angular.module('minto.core', [
    'ui.router',
    'pascalprecht.translate',
    'ngCookies',
    'ngSanitize',
    'ngStorage',
    'ui.bootstrap.tabs',
    'cfp.hotkeys',
    'rzModule',
    'hl.sticky'
]);

core.constant('local', (() => {
    let isLocal = document.location.hostname === 'localhost';
    return isLocal;
})());

core.constant('APIEndpoint', APIEndpoint());
core.constant('GlobalRedirects', GlobalRedirects());
core.factory('interceptor', InterceptorsService);

core.config(routeConfig);
core.config(localeConfig);
core.run(runFunc);

function runFunc($translate, $cookies, $templateCache) {
    'ngInject';
    (($translate, $cookies) => {
        $translate.use('en');
        // if (angular.isUndefined($cookies.get('lang'))) {
        //     $translate.use('en');
        // } else {
        //     $translate.use($cookies.get('lang'));
        // }
    })($translate, $cookies);

    $templateCache.put('uib/template/tabs/tabset.html',
        `<div>
                <ul class="tabs" ng-transclude></ul>
                <div class="tab-content">
                    <div class="content-item"
                        ng-repeat="tab in tabset.tabs"
                        ng-class="{active: tabset.active === tab.index}"
                        uib-tab-content-transclude="tab">
                    </div>
                </div>
            </div>`);

    $templateCache.put('uib/template/tabs/tab.html',
        `<li ng-class="[{active: active, disabled: disabled}, classes]" class="tab-item">
                <a href ng-click="select($event)" class="nav-link" uib-tab-heading-transclude>{{heading}}</a>
            </li>`);

}

export default core;



// WEBPACK FOOTER //
// ./client/app/core/core.module.js